export default __webpack_public_path__ + "static/media/BG-bottom.f96cc8e4.jpg";